exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-views-base-entry-js": () => import("./../../../src/views/base-entry.js" /* webpackChunkName: "component---src-views-base-entry-js" */),
  "component---src-views-noindex-entry-js": () => import("./../../../src/views/noindex-entry.js" /* webpackChunkName: "component---src-views-noindex-entry-js" */),
  "component---src-views-projects-entry-js": () => import("./../../../src/views/projects-entry.js" /* webpackChunkName: "component---src-views-projects-entry-js" */)
}

